import { createApp } from 'vue';
import App from './App.vue';
import * as EvaIcons from '@stefandesu/eva-icons-vue';
import store from './state/store';
import router from './router';
import ActionCableVue from 'actioncable-vue';
import BootstrapVue3 from 'bootstrap-vue-3';
import VueApexCharts from 'vue3-apexcharts';
import vClickOutside from 'click-outside-vue3';
import Maska from 'maska';
import Toast from 'vue-toastification';
import authService from './services/auth.services';
import customAlert from './utils/customAlert/customAlert';
import utils from './utils/functions';
import apiService from './services/api.services';
import consts from './utils/consts';
import { i18n } from '@/plugins/i18n';
import { BootstrapVue } from 'bootstrap-vue';
import Layout from '@/views/layouts/main';
import Skeleton from '@/components/bootstrap/skeleton';
import affiliateSelector from '@/components/selectors/affiliateSelector';
import genericSelector from '@/components/selectors/genericSelector';
import global from './global.js';
import setupTheme from './themes/setupTheme.js';

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import './assets/scss/custom/plugins/mermaid.min.css';
import 'vue-toastification/dist/index.css';

import './assets/scss/app.scss';
import './themes/betsul/style.scss';
import './themes/lotese/style.scss';

const websocketOptions = {
  debug: true,
  debugLevel: 'error',
  connectionUrl: 'http://localhost:8080/',
  connectImmediately: false
};

const options = {
  // You can set your default options here
};

const app = createApp(App);

app.config.globalProperties.$auth = authService;
app.config.globalProperties.$customAlert = customAlert;
app.config.globalProperties.$api = apiService;
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$consts = consts;

app.component('sysa-layout', Layout);
app.component('sysa-skeleton', Skeleton);
app.component('affiliate-selector', affiliateSelector);
app.component('generic-selector', genericSelector);
app.mixin(global);
setupTheme();

app
  .use(i18n)
  .use(store)
  .use(Toast, options)
  .use(EvaIcons)
  .use(router)
  .use(BootstrapVue3)
  .use(BootstrapVue)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(Maska)
  .use(ActionCableVue, websocketOptions)
  .mount('#app');
